import { OverridableComponent } from '@mui/material/OverridableComponent';
import { SvgIconTypeMap } from '@mui/material/SvgIcon';
import { IconButton, Tooltip } from '@mui/material';

interface IProps {
  icon: OverridableComponent<SvgIconTypeMap>;
  tooltip: string;
  size: 'small' | 'medium' | 'large';
  disabled: boolean;
  onClick: () => void;
}

export function ToolbarIconButton({ icon: Icon, tooltip, size, disabled, onClick }: IProps) {
  return (
    <Tooltip title={tooltip}>
      <span>
        <IconButton
          size={size}
          onClick={onClick}
          disabled={disabled}
          sx={{
            padding: '4px',
          }}
        >
          <Icon fontSize={size} />
        </IconButton>
      </span>
    </Tooltip>
  );
}
